const { busApi } = require('./API');

class BusinessService {
  // List All Businesses
  static async listBusinesses(token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get('');
    const { data } = res;
    return data;
  }

  // Get Business
  static async getBusiness(id, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get(`${id}`);
    const { data } = res;
    return data;
  }

  // Create Business
  static createBusiness(newBusiness, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.post('', newBusiness);
  }

  // Delete Business
  static async deleteBusiness(id, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.delete(`${id}`);
  }

  // Update Business
  static async updateBusiness(updatedBusiness, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.put(`${updatedBusiness.businessId}`, updatedBusiness);
  }

  // Save Payroll Credentials
  static async saveCredentials(businessId, credentials, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.post(`${businessId}/authorise`, credentials);
  }

  // Get Payroll Options
  static async getPayrollOptions(businessId, token, type) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get(`${businessId}/payrollOptions?type=${type}`);
    const { data } = res;
    return data;
  }

  static async getAlcomeasureToken(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.get(`${businessId}/alcomeasure/token`);
  }

  static async saveAlcomeasureSiteEmails(businessId, token, sites) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.post(`${businessId}/alcomeasure/siteemails`, sites);
  }

  static async saveRoundingSettings(businessId, token, settings) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    return busApi.post(`${businessId}/roundingSettings`, settings);
  }

  static async getRoundingSettings(businessId, token) {
    busApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await busApi.get(`${businessId}/roundingSettings`);
    const { data } = res;
    return data;
  }
}

export default BusinessService;
